/**
 * LETS USE `log()` instead of `console.log()`
 */
let logFn = console.log.bind(window.console)
if (process.env.NODE_ENV === 'production') {
  logFn = () => { }
}
window.log = logFn

export default window.log